<app-leave-page-confirmation #exitConfirmOverlay></app-leave-page-confirmation>

<div class="container" *ngIf="viewInit; else loadingSpinner">
    <div class="wrapper">
        <div class="header">
            <div class="title-container">
                <input
                    data-cy="graphs-editable-title"
                    id="input-bar"
                    type="text"
                    class="title"
                    [value]="initName"
                    [(ngModel)]="name"
                    [placeholder]="
                        'forms.channels.custom-group.title.placeholder'
                            | translate
                    "
                    maxlength="32"
                    autocomplete="off"
                    (click)="displayNameClick($event)"
                />
                <app-used-titles-suggestions
                    data-cy="graphs-editable-title-suggestion"
                    *ngIf="displayNameFocus"
                    [titleList]="getTitleList()"
                    (onHideSuggestions)="displayNameInputBlur()"
                    (onTitleSelected)="selectDisplayName($event)"
                ></app-used-titles-suggestions>
                <app-validation-error-label
                    data-cy="graphs-editable-title-validation-warning"
                    class="name-error-message"
                    [class.show]="titleIsRepeated()"
                    [message]="titleError"
                ></app-validation-error-label>
            </div>

            <div class="buttons">
                <div
                    data-cy="custom-channel-group-cancel-button"
                    class="button"
                    (click)="cancel()"
                >
                    {{
                        "forms.channels.custom-group.buttons.cancel" | translate
                    }}
                </div>
                <button
                    data-cy="custom-channel-group-save-button"
                    class="button submit"
                    [disabled]="
                        editCustomGraphId
                            ? checkEditRequiredConditions()
                            : checkCreateRequiredConditions()
                    "
                    (click)="submit($event)"
                >
                    {{
                        (editCustomGraphId
                            ? "forms.channel.alarm.button.edit"
                            : "forms.channel.alarm.button.create"
                        ) | translate
                    }}
                </button>
            </div>
        </div>
        <div class="share-settings-container">
            <app-page-share-settings
                [ngClass]="'share-settings-wrapper'"
                [isPublic]="isPublicGraph"
                [isCreating]="!editCustomGraphId"
                [usersAccess]="usersAccess"
                [isCreating]="true"
                (onAccessChanged)="handleAccessChanged($event)"
                (onUserPermissionChanged)="handleUserAccessChanged($event)"
            ></app-page-share-settings>
        </div>
        <div class="content">
            <div class="indicator-wrapper">
                <app-custom-graph-empty
                    *ngFor="let indicator of [].constructor(32); let i = index"
                    [selected]="selectedNum === i"
                    (click)="emptyGraphClick($event, i)"
                ></app-custom-graph-empty>
            </div>
            <div class="graph-container" #graphContainer>
                <div
                    class="custom-graph-container"
                    *ngFor="let item of itemList; let i = index"
                    [style.top]="item?.y + 'px'"
                    [style.left]="item?.x + 'px'"
                    [class.gauge]="isCustomGraphTypeGauge(item)"
                    [class.meter]="isCustomGraphTypeMeter(item)"
                    [class.indicator]="isCustomGraphTypeIndicator(item)"
                    [class.select]="selectedNum === i"
                    (click)="customGraphClick($event, item, i)"
                >
                    <app-gauge-graph
                        class="custom-graph"
                        *ngIf="isCustomGraphTypeGauge(item)"
                        [channel]="item?.channel"
                        [divisions]="item?.divisions"
                        [inCustomEditMode]="true"
                        (onRemoveItem)="removeItem(item)"
                    ></app-gauge-graph>
                    <app-custom-bar-graph
                        class="custom-graph"
                        *ngIf="isCustomGraphTypeMeter(item)"
                        [channel]="item?.channel"
                        [divisions]="item?.divisions"
                        [inEditMode]="true"
                        (onRemoveItem)="removeItem(item)"
                    ></app-custom-bar-graph>
                    <app-custom-indicator-graph
                        class="custom-graph"
                        *ngIf="isCustomGraphTypeIndicator(item)"
                        [channel]="item?.channel"
                        [divisions]="item?.divisions"
                        [isCustom]="item.isCustom"
                        [inEditMode]="true"
                        (onRemoveItem)="removeItem(item)"
                    ></app-custom-indicator-graph>
                </div>
            </div>
        </div>
    </div>
</div>

<app-custom-graph-dialog
    [isFromRight]="isFromRight"
    [showDialog]="isDialogOpen"
    [selectedCustomGraphItem]="itemList[selectedNum]"
    [selectedNum]="selectedNum"
    (onCloseDialog)="closeDialog()"
    (onSetCustomGraph)="setCustomGraph($event)"
    [graphContainer]="graphContainer"
    [itemList]="itemList"
    [selectedCoord]="selectedCoord"
>
</app-custom-graph-dialog>

<ng-template #loadingSpinner>
    <div class="loading-spinner-container">
        {{ "general.notification.retreiving-data" | translate }}
        <app-loading-spinner
            style="height: 200px; width: 200px"
        ></app-loading-spinner>
    </div>
</ng-template>
